(ns frontend.ui.component.lp-portal.report.body.private-equity.fund.infra.pdf.view
  (:require
   [frontend.ui.component.lp-portal.card.pdf.view :as card]
   [frontend.ui.component.lp-portal.column.pdf.view :as column]
   [frontend.ui.component.lp-portal.page.pdf.view :as page]
   [frontend.ui.component.lp-portal.table.pdf.view :as table]
   [frontend.ui.component.lp-portal.text-content.pdf.view :as text-content]
   [frontend.ui.component.lp-portal.page.pdf.view :as page]
   [frontend.ui.page.lp-portal.report.pdf.view :as report]
   [frontend.ui.component.lp-portal.report.body.private-equity.pdf.view.details-and-figures :as
    pe-view-details-and-figures]
   [frontend.ui.component.lp-portal.report.body.private-equity.pdf.view.esg :as pe-view-esg]
   [frontend.ui.component.lp-portal.report.body.private-equity.pdf.view.investors :as
    pe-view-investors]
   [frontend.ui.component.lp-portal.report.body.private-equity.pdf.view.overview :as
    pe-view-overview]
   [frontend.ui.component.lp-portal.report.body.private-equity.pdf.view.tearsheet :as
    pe-view-tearsheet]
   [frontend.ui.style.theme.core :as theme]))

(defn finance-summary-pages
  [report-data]
  (table/dynamic-table-pages
   {:fund-name (:fund-name report-data) :page-title "Finance summary" :toc-item true}
   "Bridging finance and fund leverage facilities"
   (->> report-data
        :summaries
        :finance-summary)
   {:skip-headers? true
    :odd-color     (theme/color [:pdf :table :odd-color])
    :even-color    (theme/color [:pdf :table :even-color])
    :heading-color (theme/color [:pdf :table
                                 :heading-color])}))

;; Infra Excel Finance summary #2 table has two heading rows. How should we display them?
(defn finance-summary-2-pages
  [report-data]
  (table/dynamic-table-pages {:fund-name (:fund-name report-data) :page-title "Finance summary"}
                             "Bridging facility, €"
                             (->> report-data
                                  :summaries
                                  :finance-summary-2)
                             {:odd-color     (theme/color [:pdf :table :odd-color])
                              :even-color    (theme/color [:pdf :table :even-color])
                              :heading-color (theme/color [:pdf :table
                                                           :heading-color])}))

(defn infra-pages
  [report-data]
  (concat
   [(page/toc-page {:cover-image :front-page-image
                    :report-data report-data})]
   [(pe-view-tearsheet/tearsheet-page report-data)]
   (pe-view-overview/overview-pages report-data)
   (pe-view-esg/esg-pages report-data)
   (pe-view-details-and-figures/details-and-figures-pages report-data)
   (pe-view-investors/investors-pages report-data)
   (finance-summary-pages report-data)
   (finance-summary-2-pages report-data)))

(defn infra
  [{:keys [fund-name reporting-period reference-date] :as view-data}]
  (report/report view-data (infra-pages view-data) fund-name reporting-period reference-date))
